import axiosInstance from "./axiosInstance";
import { catchError } from "../utils/errorHandler";

const userManagementService = {
  createUser: async (user) => {
    try {
      const response = await axiosInstance.post(
        "/useraccount/v2/create-internal-user/",
        user
      );
      if (response.status === 201) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message || "User created successfully",
        };
      } else {
        return {
          success: false,
          error: response.data?.message || "Failed to create user",
        };
      }
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },
  deactivateUser: async (uuid) => {
    try {
      const response = await axiosInstance.delete(
        `/useraccount/v2/deactivate-internal-user/${uuid}`
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      } else {
        return {
          success: false,
          error: response.data?.message || "Failed to deactivate user",
        };
      }
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },


  activateUser: async (uuid) => {
    try {
      const response = await axiosInstance.put(
        `/useraccount/v2/activate-internal-user/${uuid}/`
      );
      if (response.status === 200) {
        return { success: true, data: response.data };
      } else {
        return {
          success: false,
          error: response.data?.message || "Failed to activate user",
        };
      }
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },
  getLocationsDropdown: async () => {
    try {
      const response = await axiosInstance.get(
        "/useraccount/v2/location/dropdown/"
      );
      if (response.status === 200) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          error: response.data?.message || "Failed to fetch locations",
        };
      }
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },
  getUserList: async (page = 1, pageSize = 10, filters = {}) => {
    const {
      email,
      username,

      created_at,

      is_active,

      locations,
    } = filters;
    const query = new URLSearchParams({
      page,
      page_size: pageSize,
      ...(email && { email }),

      ...(username && { username }),
      ...(is_active && { is_active }),

      ...(locations && { locations }),
      ...(created_at && { created_at }),
    }).toString();
    try {
      const response = await axiosInstance.get(
        `/useraccount/v2/internal-user-list/?${query}`
      );
      if (response.status === 200) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          error: response.data?.message || "Failed to fetch user list",
        };
      }
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },
};

export default userManagementService;
